import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlag } from '../../data/models';
import { FeatureFlagService } from './feature-flag.service';

@Directive({
    selector: '[appFeature]',
    standalone: false
})
export class FeatureFlagDirective {
  constructor(
    private readonly featureService: FeatureFlagService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef) { }

  @Input() set appFeature(feature: FeatureFlag) {
    if (this.featureService.isAllowed(feature)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }
    this.viewContainer.clear();
  }
}
